<template>
<div class="not-found">
    <div class="not-found-wrap">
        <h1>404</h1>
        <p>抱歉！页面没找到……点击按钮返回首页或幽默笑话</p>
        <!-- <router-link to="./"><img src="../../static/img/ibroadcast/back2home3.png" width="390"></router-link> -->
         <p class="joke"><router-link to='./'>返回首页</router-link></p> 
        <p class="joke"><router-link to='./joke/list'>幽默笑话</router-link></p>

    </div>
</div>
</template>
<script>
import '../../static/style/common/notfound.scss'
</script>



// WEBPACK FOOTER //
// notfound.vue?7aebc7dc